// extracted by mini-css-extract-plugin
export var content = "TextAndCtaTwoColumn-module--content--nW41K";
export var cta = "TextAndCtaTwoColumn-module--cta--gA6De";
export var wrapper = "TextAndCtaTwoColumn-module--wrapper--8gIiC";
export var yellowTheme = "TextAndCtaTwoColumn-module--yellowTheme--HNi+G";